import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings'

export function useKambiMaintenanceFeature(): false | string {
  const isMaintenanceActive = useFeature(FeatureFlags.KAMBI_MAINTENANCE.key) as { endTime?: string }
  return isMaintenanceActive?.endTime || false
}
